import { NavLink } from "react-router";
import { EmptyState, Icon, StatusDot, useLayout, type Tone } from "@agentsaas/ui";
import type { Agent, AgentStatus } from "@agentsaas/protocol";
import { useT } from "../app/i18n";
import { useTeamInfo } from "../team/useTeam";

export const STATUS_TONE: Record<AgentStatus, Tone> = {
  provisioning: "warning",
  idle: "success",
  busy: "accent",
  waiting_approval: "warning",
  paused: "neutral",
  budget_exhausted: "danger",
  unreachable: "danger",
  error: "danger",
};

export function AgentStatusDot({ status }: { status: AgentStatus }) {
  const { t } = useT();
  return <StatusDot tone={STATUS_TONE[status]} label={t(`agent.status.${status}`)} pulse={status === "busy" || status === "provisioning"} />;
}

/** 左栏"团队"：agent 列表（状态灯、角色、当前任务） */
export function TeamList({ pid, agents }: { pid: string; agents: Agent[] }) {
  const { t } = useT();
  const mobileChat = useLayout() === "mobile";
  const info = useTeamInfo(pid);
  return (
    <nav aria-label={t("agent.team")} className="team">
      {agents.length ? (
        <ul className="list">
          {agents.map((a) => (
            <li key={a.id}>
              <NavLink to={`/p/${pid}/a/${a.id}${mobileChat ? "?tab=chat" : ""}`} className={({ isActive }) => `list-item team__item${isActive ? " is-active" : ""}`} data-testid="agent-link">
                <AgentStatusDot status={a.status} />
                <span className="grow team__text">
                  <span className="ellipsis">{a.name}</span>
                  <span className="muted small ellipsis" data-testid="agent-sub">
                    {info.roleOf(a)}
                    {info.currentTask(a) ? (
                      <>
                        <span className="sep" aria-hidden="true" />
                        {info.currentTask(a)!.title}
                      </>
                    ) : null}
                  </span>
                </span>
                <span className="muted small">{t(`agent.status.${a.status}`)}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      ) : (
        <EmptyState title={t("agent.empty")} />
      )}
      <NavLink to={`/p/${pid}/new`} className="list-item team__new" data-testid="new-agent">
        <Icon name="plus" />
        <span>{t("agent.new")}</span>
      </NavLink>
    </nav>
  );
}
